import { createContext, useContext } from "react";

export const MapContext = createContext(null);

export const useMap = () => {
  const map = useContext(MapContext);

  return map;
};
